export default __webpack_public_path__ + "static/media/Xrathus-Continuous-diagram.1bacf51a.png";